// 本通结果 / Call outcome: what each call achieved. The backend aggregates
// texts, callbacks, transfers and voicemail per call (`call.outcomes`);
// ecommerce ticket-center tickets arrive separately as `call.ticket_numbers`
// (see serviceRecords.mergeTicketContacts) and are added here.

const TYPE_LABELS = {
  product_link: ['商品链接', 'Product link'],
  ticket_form: ['工单表单', 'Ticket form'],
  ticket: ['工单', 'Ticket'],
  callback: ['回电请求', 'Callback'],
  support_ticket: ['支持工单', 'Support ticket'],
  transfer: ['转接', 'Transfer'],
  voicemail: ['语音信箱', 'Voicemail'],
  unresolved: ['未解决', 'Unresolved'],
};

const STATUS_LABELS = {
  delivered: ['已送达', 'Delivered'],
  pending: ['发送中', 'Sending'],
  failed: ['失败', 'Failed'],
  gated: ['未执行', 'Blocked'],
  unknown: ['状态未知', 'Status unknown'],
};

const SMS_TYPES = new Set(['product_link', 'ticket_form']);
const RESOLVED = new Set(['delivered', 'success', 'pending', 'unknown']);

export const OUTCOME_COLORS = {
  delivered: 'green', success: 'green', pending: 'blue', unknown: 'gray', gated: 'orange', failed: 'red',
};

const pick = (pair, lang) => (pair ? pair[lang === 'zh' ? 0 : 1] : '');

const statusLabel = (item, lang) => {
  if (item.type === 'unresolved' || item.type === 'ticket') return '';
  if (item.status === 'success') {
    if (SMS_TYPES.has(item.type)) return lang === 'zh' ? '已发送' : 'Sent';
    if (item.type === 'transfer') return lang === 'zh' ? '已转接' : 'Connected';
    return '';
  }
  if (item.status === 'pending' && !SMS_TYPES.has(item.type)) return lang === 'zh' ? '处理中' : 'Pending';
  return pick(STATUS_LABELS[item.status], lang);
};

// Short text for a badge: "商品链接 · 已送达", "回电请求 CB…", "转接 205 · 失败".
export const outcomeLabel = (item, lang = 'zh') => {
  const type = pick(TYPE_LABELS[item.type], lang) || item.type;
  const ref = item.ref && !SMS_TYPES.has(item.type) ? ` ${item.ref}` : '';
  const status = statusLabel(item, lang);
  return `${type}${ref}${status ? ` · ${status}` : ''}`;
};

export const outcomeColor = (item) => (item.type === 'unresolved' ? 'red' : OUTCOME_COLORS[item.status] || 'gray');

// Backend outcomes plus ticket-center tickets; a ticket means the call is not unresolved.
export const callOutcomes = (call) => {
  const tickets = (call?.ticket_numbers || []).map((ref) => ({ type: 'ticket', status: 'success', ref, label: '', at: null }));
  const base = Array.isArray(call?.outcomes) ? call.outcomes : [];
  const merged = tickets.length ? [...tickets, ...base.filter((item) => item.type !== 'unresolved')] : base;
  return merged.filter((item) => item && TYPE_LABELS[item.type]);
};

export const isUnresolved = (call) => {
  const items = callOutcomes(call);
  return items.some((item) => item.type === 'unresolved') && !items.some((item) => item.type !== 'unresolved' && RESOLVED.has(item.status));
};

export const OUTCOME_FILTERS = { all: () => true, unresolved: isUnresolved };

// Where the caller's follow-up lives; null when the page is not available.
export const outcomeLink = (item, { callbackPath, callRef }) => {
  const ref = item.call_ref || callRef;
  if (!callbackPath || !ref || !['callback', 'support_ticket'].includes(item.type)) return null;
  return `${callbackPath}?call_session_id=${encodeURIComponent(ref)}`;
};

export const outcomeDetail = (item, lang = 'zh') => {
  const parts = [];
  if (SMS_TYPES.has(item.type) && item.ref) parts.push(`${lang === 'zh' ? '手机' : 'Phone'} •••${item.ref}`);
  if (item.label) parts.push(item.label);
  if (item.error) parts.push(`${lang === 'zh' ? '原因' : 'Reason'}: ${item.error}`);
  return parts.join(' · ');
};
